/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Hero_Title_1Inputs */

const tr_landing_hero_title_1 = /** @type {(inputs: Landing_Hero_Title_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-ticaretin`)
};

const en_landing_hero_title_1 = /** @type {(inputs: Landing_Hero_Title_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Break the chains`)
};

const de_landing_hero_title_1 = /** @type {(inputs: Landing_Hero_Title_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sprengen Sie die Ketten`)
};

const ru_landing_hero_title_1 = /** @type {(inputs: Landing_Hero_Title_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Разорвите цепи`)
};

/**
* | output |
* | --- |
* | "Break the chains" |
*
* @param {Landing_Hero_Title_1Inputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const landing_hero_title_1 = /** @type {((inputs?: Landing_Hero_Title_1Inputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Hero_Title_1Inputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_hero_title_1(inputs)
	if (locale === "de") return de_landing_hero_title_1(inputs)
	if (locale === "ru") return ru_landing_hero_title_1(inputs)
	return tr_landing_hero_title_1(inputs)
});